import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import WhatWeDo from "@/components/site/WhatWeDo";
import Marquee from "@/components/site/Marquee";
import Work from "@/components/site/Work";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <Nav />
      <Hero />
      <Manifesto />
      <WhatWeDo />
      <Marquee />
      <Work />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
